import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  tabindex: "0",
  ref: "tag_selector_target",
  class: "full-width"
}
const _hoisted_2 = { style: {"height":"100%","overflow":"hidden"} }
const _hoisted_3 = { class: "q-pa-xs q-mb-xs text-center tag-header" }
const _hoisted_4 = {
  class: "q-px-xs q-py-none col",
  style: `height: calc(100% - 35px); overflow: auto;`
}
const _hoisted_5 = {
  class: "q-px-xs q-py-none",
  style: {"height":"100%","overflow":"hidden"}
}
const _hoisted_6 = { class: "q-pa-xs q-mb-xs text-center tag-header" }
const _hoisted_7 = {
  class: "q-px-xs q-py-none col",
  style: `height: calc(100% - 35px); overflow: auto;`
}
const _hoisted_8 = {
  class: "q-px-xs q-py-none",
  style: {"height":"100%","overflow":"hidden"}
}
const _hoisted_9 = { class: "q-pa-xs q-mb-xs text-center tag-header" }
const _hoisted_10 = {
  class: "q-px-xs q-py-none col",
  style: `height: calc(100% - 35px); overflow: auto;`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_simple_element = _resolveComponent("simple-element")!
  const _component_variable_list = _resolveComponent("variable-list")!
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.full)
      ? (_openBlock(), _createBlock(_component_q_splitter, {
          key: 0,
          modelValue: _ctx.splitterModel.outerModel,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.splitterModel.outerModel) = $event)),
          style: _normalizeStyle(`${_ctx.mHeight ? `height: ${_ctx.mHeight}px;` : 'height: 50vh;'} width: 50vw;`)
        }, {
          before: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tagSegmentLabel), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_variable_list, {
                  ref: "simple_selector_list",
                  elements: _ctx.tags_filtered.AllSystemTags,
                  modelValue: _ctx.theModel,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event)),
                  "allow-multiple": true,
                  "show-checkbox": true,
                  "allow-wrap": true,
                  style: {"padding-left":"4px"},
                  "model-type": 1,
                  viewport: _ctx.$refs.tag_selector_target,
                  "key-prefix": "alltag_",
                  "key-id": "Id"
                }, {
                  default: _withCtx((slotProps) => [
                    _createVNode(_component_simple_element, {
                      element: slotProps.item,
                      elementType: 1,
                      filter_string: _ctx.filter_string
                    }, null, 8, ["element", "filter_string"])
                  ]),
                  _: 1
                }, 8, ["elements", "modelValue", "viewport"])
              ])
            ])
          ]),
          after: _withCtx(() => [
            _createVNode(_component_q_splitter, {
              class: "full-width",
              modelValue: _ctx.splitterModel.innerModel,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.splitterModel.innerModel) = $event)),
              horizontal: ""
            }, {
              before: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('top_tags_user')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_variable_list, {
                      ref: "simple_selector_list",
                      elements: _ctx.tags_filtered.OftenUsedByUserTags,
                      modelValue: _ctx.theModel,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.theModel) = $event)),
                      "allow-multiple": true,
                      "show-checkbox": true,
                      "allow-wrap": true,
                      style: {"padding-left":"4px"},
                      "model-type": 1,
                      viewport: _ctx.$refs.tag_selector_target,
                      "key-prefix": "ofusertag_",
                      "key-id": "Id"
                    }, {
                      default: _withCtx((slotProps) => [
                        _createVNode(_component_simple_element, {
                          element: slotProps.item,
                          elementType: 1,
                          filter_string: _ctx.filter_string
                        }, null, 8, ["element", "filter_string"])
                      ]),
                      _: 1
                    }, 8, ["elements", "modelValue", "viewport"])
                  ])
                ])
              ]),
              after: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('top_tags_entity')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_variable_list, {
                      ref: "simple_selector_list",
                      elements: _ctx.tags_filtered.OftenUsedForEntityTags,
                      modelValue: _ctx.theModel,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.theModel) = $event)),
                      "allow-multiple": true,
                      "show-checkbox": true,
                      "allow-wrap": true,
                      style: {"padding-left":"4px"},
                      "model-type": 1,
                      viewport: _ctx.$refs.tag_selector_target,
                      "key-prefix": "ofenttag_",
                      "key-id": "Id"
                    }, {
                      default: _withCtx((slotProps) => [
                        _createVNode(_component_simple_element, {
                          element: slotProps.item,
                          elementType: 1,
                          filter_string: _ctx.filter_string
                        }, null, 8, ["element", "filter_string"])
                      ]),
                      _: 1
                    }, 8, ["elements", "modelValue", "viewport"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue", "style"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "full-width",
          style: _normalizeStyle(_ctx.mHeight ? `height: ${_ctx.mHeight}px; overflow: auto;` : 'height: 100%; overflow: auto;')
        }, [
          _createVNode(_component_variable_list, {
            ref: "compact_selector_list",
            elements: _ctx.tags_filtered.OftenUsedForEntityTags,
            modelValue: _ctx.theModel,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.theModel) = $event)),
            "allow-multiple": true,
            "show-checkbox": true,
            "allow-wrap": true,
            viewport: _ctx.$refs.tag_selector_target,
            style: {"padding-left":"4px"},
            "key-prefix": "ofenttag_",
            "key-id": "Id"
          }, {
            default: _withCtx((slotProps) => [
              _createVNode(_component_simple_element, {
                element: slotProps.item,
                elementType: 1,
                filter_string: _ctx.filter_string
              }, null, 8, ["element", "filter_string"])
            ]),
            _: 1
          }, 8, ["elements", "modelValue", "viewport"])
        ], 4))
  ], 512))
}